import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PoBreadcrumb, PoDialogService, PoDynamicFormField, PoLookupComponent, PoNotificationService, PoPageSlideComponent, PoTableColumn } from '@po-ui/ng-components';
import { ProcessoCadastro, defaultProcessoCadastro } from 'src/app/administrativo/interface/processo-cadastro';
import { ProcessoPreCadastroProduto, ProcessoPreCadastroProdutoDto, defaultProcessoPreCadastroProduto } from 'src/app/administrativo/interface/processo-pre-cadastro-produto';
import { ProcessoCadastroService } from 'src/app/administrativo/service/processo-cadastro';
import { AuthService } from 'src/app/service/auth.service';
import { BaseService } from 'src/app/service/base-service';
import { UtilService } from 'src/app/service/util';
import { UtilArquivo } from 'src/app/util/arquivo/util-arquivo.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pre-cadastro-produto-crud',
  templateUrl: './pre-cadastro-produto-crud.component.html',
  styleUrls: ['./pre-cadastro-produto-crud.component.css']
})
export class PreCadastroProdutoCrudComponent implements OnInit {

  preProduto: ProcessoPreCadastroProduto = defaultProcessoPreCadastroProduto();
  processoCadastro: ProcessoCadastro = defaultProcessoCadastro();

  bloqueiaDadosSolicitante: boolean = true;
  bloqueiaDadosCompras: boolean = true;
  bloqueiaDadosControladoria: boolean = true;
  bloqueiaFamiliaEstrutural: boolean = false;

  usuarioLogado: string = '';
  fileChave: string = '';
  fileAlias: string = 'IMGPRODUTO';

  usuarioSolicitante: boolean = false;
  usuarioEngenharia: boolean = false;
  usuarioCompras: boolean = false;
  usuarioControladoria: boolean = false;

  liberaAvancarProcesso: boolean = true;

  tabelaHistorico: Array<any> = [];

  historico: string = '';
  urgente: string = 'N';

  urlApiProtheus: string = environment.urlApiProtheus;

  breadcrumb: PoBreadcrumb = {
    items: [
      {label: 'Home', action: this.goHome.bind(this)},
      {label: 'Lista', action: this.goLista.bind(this)},
      {label: 'Pré-cadastro Produto'},
    ],
  };

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private poNotificationService: PoNotificationService,
    private poDialogService: PoDialogService,
    private utilService: UtilService,
    private baseService: BaseService,
    private authService: AuthService,
    private processoCadastroService: ProcessoCadastroService,

  ) { }

  @ViewChild('formPrincipal', { static: true }) formPrincipal!: NgForm;
  @ViewChild('utilArquivo', { static: true }) utilArquivo!: UtilArquivo;
  @ViewChild('anexoPageSlide', { static: true }) anexoPageSlide!: PoPageSlideComponent;

  ngOnInit(): void {

    this.usuarioLogado = localStorage.getItem('CUSRID') || '';
    this.fileChave = this.utilService.getUniqueId(4);

    this.activatedRoute.params.subscribe({
      next : (params) => {
        if ('NPROCESSOCODIGO' in params && 'NCODIGO' in params) {
          this.loadDados(params.NPROCESSOCODIGO, params.NCODIGO)
        } else {
          this.bloqueiaDadosSolicitante = false;
        }
      },error: () => {
        this.poNotificationService.warning('Dados de acesso inválidos!');
        this.goLista();
      }
    })

  }

  loadDados(NPROCESSOCODIGO: number, NCODIGO: number):void{

    this.processoCadastroService.getProcCadastro(NPROCESSOCODIGO).subscribe({
      next: (ret) => {
        this.processoCadastro = ret;

        this.urgente = ret.CURGENTE;

        this.usuarioSolicitante = (this.processoCadastro.CCODIGOUSUARIOPROTHEUS === this.usuarioLogado);

        this.authService.validaPrivilegio(['PORTAL_ADMINISTRADOR', 'PO_PRECAD_COMPRAS']).then((temPermissao) => {
          this.usuarioCompras = temPermissao;
        });

        this.authService.validaPrivilegio(['PORTAL_ADMINISTRADOR', 'PO_PRECAD_CONTROLADORIA']).then((temPermissao) => {
          this.usuarioControladoria = temPermissao;
        });

        this.authService.validaPrivilegio(['PORTAL_ADMINISTRADOR', 'PO_PRECAD_ENGENHARIA']).then((temPermissao) => {
          this.usuarioEngenharia = temPermissao;
          this.liberaTela();
        });

        this.processoCadastroService.getProcCadastroPreProduto(NCODIGO).subscribe({
          next: (ret) => {
            this.preProduto = {...defaultProcessoPreCadastroProduto(), ...ret};

            if (this.preProduto.CB1COD){
              this.fileChave = this.preProduto.CB1COD;
            } else {
              this.fileChave = `PRE${NCODIGO}`;
            }

            if (['3','6'].includes(this.processoCadastro.CSTATUS) && this.usuarioCompras){
              if (this.preProduto.CB1GRUPO === undefined ||this.preProduto.CB1GRUPO.length === 0){
                this.bloqueiaFamiliaEstrutural = true;
              } else {
                this.bloqueiaFamiliaEstrutural = false;
              }
            }

          }
          ,error: () => {
            this.goLista();
          }
        });

        this.processoCadastroService.getProcCadastroHistoricoLista(NPROCESSOCODIGO).subscribe({
          next: (historico) => {
            this.tabelaHistorico = historico.items;
          }
        });

      }
      ,error: () => {
        this.goLista();
      }
    })

  }

  liberaTela():void{
    if (['1','4'].includes(this.processoCadastro.CSTATUS) && this.usuarioEngenharia){
      this.bloqueiaDadosSolicitante = false;
    } else if (this.processoCadastro.CSTATUS === '2' && this.usuarioSolicitante){
      this.bloqueiaDadosSolicitante = false;
    } else if (['3','6'].includes(this.processoCadastro.CSTATUS) && this.usuarioCompras){
      this.bloqueiaDadosCompras = false;
    } else if (['5','8'].includes(this.processoCadastro.CSTATUS) && this.usuarioControladoria){
      this.bloqueiaDadosSolicitante = false;
      this.bloqueiaDadosCompras = false;
      this.bloqueiaDadosControladoria = false;
    } else {
      this.liberaAvancarProcesso = false;
    }
  }


  gravarDados(decisao: string):void{

    const dados: ProcessoPreCadastroProdutoDto = {
      CURGENTE: this.urgente,
      PRODUTO: this.preProduto,
      CHISTORICO: this.historico,
      CDECISAO: decisao,
      CARQUIVOSCHAVE: this.fileChave,
    };

    this.processoCadastroService.postProcCadastroPreProduto(dados).subscribe({
      next: (ret) => {
        this.goLista();
      }
    })

  }

  confirmarTela():void{

    if(this.preProduto.CB1SEGUM !== ""){
      if(!(this.preProduto.NB1CONV > 0.00000000)){
        this.poNotificationService.warning("O valor do campo Fator de Conversão de UM é inferior ao valor MÍNIMO permitido. (0.00000001)");
        return
      }
    }

    if (this.formPrincipal.valid){
      let texto = '';
      if (this.processoCadastro.NCODIGO <= 0){
        texto = 'Deseja incluir a solicitação de cadastro de produto?'
      } else {
        texto = 'Deseja aprovar a solicitação de cadastro de produto?'
      }

      this.poDialogService.confirm({
        title: 'Avançar processo',
        message: texto,
        confirm: () =>{
          this.gravarDados('A');
        }
      })
    } else {
      this.utilService.showErrosFomulario(this.formPrincipal,document);
    }

  }

  cancelarRecusarTela():void{
    if (this.processoCadastro.CSTATUS){
      if (this.historico){
        this.poDialogService.confirm({
          title: 'Recusar processo',
          message: 'Deseja Recusar o cadastro deste Produto?',
          confirm: () =>{
            this.gravarDados('R');
          }
        })
      } else {
        this.poNotificationService.warning({
          message: 'Informe uma observação para poder recusar o cadastro do produto.',
          duration: 5000
        })
      }
    } else {
      this.poDialogService.confirm({
        title: 'Cancelar Solicitação',
        message: 'Deseja sair da tela e cancelar a solicitação de cadastro de produto?',
        confirm: () =>{
          this.goLista();
        }
      })
    }
  }

  changeGrupo(): void {
    if (['3','6'].includes(this.processoCadastro.CSTATUS) && this.usuarioCompras){
      if (this.preProduto.CB1GRUPO === undefined || this.preProduto.CB1GRUPO.length === 0){
        this.bloqueiaFamiliaEstrutural = true;
      } else {
        this.bloqueiaFamiliaEstrutural = false;
      }
    }
  }

  goLista(): void {
    this.router.navigateByUrl('administrativo/pre-cadastro/produto/lista');
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //##############################################
  // arquivos
  //##############################################
  arquivosLoadDados(): void {
    this.utilArquivo.empresa = '01',
    this.utilArquivo.filial  = '01',
    this.utilArquivo.arquivosLoadDados(this.fileAlias, this.fileChave);
    this.anexoPageSlide.open();
  }

  public readonly tabelaHistoricoColunas: Array<PoTableColumn> = [
    {property: 'CCODIGOUSUARIOPROTHEUS_NOME', label: 'Usuário'   , width: '15%', visible: true},
    {property: 'DDATA'                      , label: 'Data'      , width: '10%', visible: true, type: 'date', format: 'dd/MM/Y'},
    {property: 'CHORA'                      , label: 'Hora'      , width: '10%', visible: true},
    {property: 'CSTATUS' , width: '10%' , label: 'Status' , visible: true, type: 'label' ,
      labels: [
        { value: '2', color: 'color-01', label: 'Solicitante'},
        { value: '1', color: 'color-03', label: 'Engenharia'},
        { value: '4', color: 'color-04', label: 'Gerência Negado'},
        { value: '3', color: 'color-05', label: 'Compras'},
        { value: '6', color: 'color-06', label: 'Compras Negado'},
        { value: '5', color: 'color-07', label: 'Controladoria'},
        { value: '8', color: 'color-08', label: 'Controladoria Negado'},
        { value: '9', color: 'color-10', label: 'Finalizado'},
        { value: 'A', color: 'color-12', label: 'Cancelado'},
      ]
    },
    {property: 'COBSERVACAO'                , label: 'Observação', width: '55%', visible: true},
  ]

}
